<app-modal
  [title]="'Select ticket for voucher' | trans:'vouchers/external-voucher-ticket-picker-modal/header/title'"
  maxWidth="728px"
  width="100%"
>
  <ng-template>
    @if (!data?.length) {
      <p class="p2">
        {{ 'Add a ticket to the cart first.' | trans:'vouchers/external-voucher-ticket-picker-modal/empty.Text' }}
      </p>
    } @else {
      <div class="group">
        <div class="d-flex flex-direction-column gap-16">
          @for (item of groupedShows; track item.showId + '_' + item.showBegin + '_' + item.auditoriumName + '_' + item.cinemaName) {
            <div class="d-flex flex-direction-column gap-8">
              <div class="d-flex align-items-center gap-16 p2">
                <span class="fw-semibold">{{ item.showTitle }}</span>
                <span>{{ item.showBegin | localeDatetimeFormat }}</span>

                @if (cartStore.showTicketCinemaName()) {
                  <span>{{ item.cinemaName }}</span>
                }

                <span>{{ item.auditoriumName }}</span>
              </div>
              @for (ticket of item.tickets; track ticket.itemId + '_' + ticket.position) {
                <div
                  class="p-8 d-flex align-items-center gap-16 base-border-radius product cursor-pointer"
                  [class.selected]="selectedTicket === ticket"
                  (click)="selectTicket(ticket)"
                >
                  <div class="d-flex align-items-center justify-content-space-between gap-16 flex-grow-1">
                    <span class="p2">
                      {{ 'Row' | trans:'cart/ticket/row.Label' }} <b>{{ ticket.seatRow }}</b> /
                      {{ 'Seat' | trans:'cart/ticket/seat.Label' }} <b>{{ ticket.seatNr }}</b> –
                      <b>{{ ticket.priceCategoryToken || ticket.priceCategory }}</b>
                    </span>
                    <span class="p2">{{ ticket.totalPrice | numberToCurrency }} {{ languageConfig.currency.short }}</span>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
  </ng-template>

  <ng-container modal-buttons>
    <div class="d-flex gap-16 m-t-16 justify-content-flex-end">
      <button
        class="button button--md button--primary-ghost text-uppercase"
        type="button"
        (click)="close()"
      >
        {{ 'Cancel' | trans:'vouchers/external-voucher-ticket-picker-modal/cancel.Button' }}
      </button>
      @if (data?.length) {
        <button
          class="button button--md button--primary text-uppercase"
          type="button"
          [disabled]="!selectedTicket"
          (click)="confirm()"
        >
          {{ 'Confirm' | trans:'vouchers/external-voucher-ticket-picker-modal/confirm.Button' }}
        </button>
      }
    </div>
  </ng-container>
</app-modal>
